import { Col, Input, Label, Row } from "reactstrap";
import React, { useEffect } from "react";
import Select from "../../Common/AppSelect";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { requestSubscriptionLicensesOrderPreview } from "../../../store/manageLicense/action";
// Change #100462
import EnterpriseSeats, {
  useSubscriptionBilling,
  isEnterpriseBilling,
  enterpriseCanAdd,
} from "./EnterpriseSeats";

const TabSubscriptionPlans = ({
  createUpdateData,
  setCreateUpdateData,
  activeVerticalTab,
  setActiveVerticalTab,
}) => {
  // Get the subscription product list from the store
  const { getLicensesSubscriptionProductListAPI } = useSelector((state) => ({
    getLicensesSubscriptionProductListAPI:
      state.ManageLicense.subscriptionProductList?.subscriptionproduct_list,
  }));

  // Change #100462 - an Enterprise company has one plan and no prices: show
  // its seats instead of the picker. The plan itself is sent by index.js.
  const billing = useSubscriptionBilling();
  const isEnterprise = isEnterpriseBilling(billing);

  if (isEnterprise) {
    return (
      <Row>
        <div>
          <h2>Your Plan</h2>
        </div>
        <hr />
        <Col lg={12} className={"p-2"}>
          <EnterpriseSeats billing={billing} adding={1} />
        </Col>
        <Col lg={12} className={"p-2"}>
          <div className={"d-flex justify-content-between mt-2 "}>
            <button
              type="button"
              className={"btn btn-primary"}
              onClick={() => setActiveVerticalTab(activeVerticalTab - 1)}
            >
              <i className="ri-arrow-left-line align-bottom me-1" />
              Back
            </button>
            <button
              type="button"
              className={"btn btn-success"}
              disabled={!enterpriseCanAdd(billing)}
              onClick={() => setActiveVerticalTab(activeVerticalTab + 1)}
            >
              Next
              <i className="ri-arrow-right-line align-bottom ms-1" />
            </button>
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <div>
        <h2>Subscription Plans</h2>
      </div>
      <hr />
      <Col lg={12} className={"p-2"}>
        <Label>
          Subscription Product <span className={"text-danger"}>*</span>
        </Label>
        <Select
          isMulti={true}
          options={getLicensesSubscriptionProductListAPI?.map(
            (item) =>
              item?.Name && {
                value: item?.Id,
                label:
                  item?.Name +
                  " £" +
                  item?.AmountLocalTotal +
                  " INC.VAT " +
                  (getLicensesSubscriptionProductListAPI?.find(
                    (role) => role?.Id === item?.Id
                  )?.QtyLicenceAvailable > 0
                    ? "(" +
                      getLicensesSubscriptionProductListAPI?.find(
                        (role) => role?.Id === item?.Id
                      )?.QtyLicenceAvailable +
                      " Licenses Available)"
                    : ""),
              }
          )}
          value={
            isEmpty(createUpdateData?.subscriptionproduct_list)
              ? []
              : createUpdateData?.subscriptionproduct_list?.map((item) => {
                  return {
                    value: item?.Id,
                    label:
                      getLicensesSubscriptionProductListAPI?.find(
                        (role) => role?.Id === item?.Id
                      )?.Name +
                      "  £" +
                      getLicensesSubscriptionProductListAPI?.find(
                        (role) => role?.Id === item?.Id
                      )?.AmountLocalTotal +
                      " INC.VAT " +
                      (getLicensesSubscriptionProductListAPI?.find(
                        (role) => role?.Id === item?.Id
                      )?.QtyLicenceAvailable > 0
                        ? "(" +
                          getLicensesSubscriptionProductListAPI?.find(
                            (role) => role?.Id === item?.Id
                          )?.QtyLicenceAvailable +
                          " Licenses Available)"
                        : ""),
                  };
                })
          }
          onChange={(e) => {
            setCreateUpdateData({
              ...createUpdateData,
              subscriptionproduct_list: e.map((item) => {
                return {
                  Id: item.value,
                };
              }),
            });
          }}
        ></Select>
      </Col>
      <Col lg={12} className={"p-2"}>
        <div className={"d-flex justify-content-between mt-2 "}>
          <button
            type="button"
            className={"btn btn-primary"}
            onClick={() => {
              setActiveVerticalTab(activeVerticalTab - 1);
            }}
          >
            <i className="ri-arrow-left-line align-bottom me-1" />
            Back
          </button>
          <button
            type="button"
            className={"btn btn-success"}
            onClick={() => {
              setActiveVerticalTab(activeVerticalTab + 1);
            }}
          >
            Next
            <i className="ri-arrow-right-line align-bottom ms-1" />
          </button>
        </div>
      </Col>
    </Row>
  );
};

export default TabSubscriptionPlans;
